import React from 'react';
import { useTranslation } from '@common/hooks/translation';
import MoneyAmount from '@common/components/moneyAmount';
import Config from '@app/dev/config/main';
import { maskPlayerName, normalizeAmount, getCurrencyConfig } from '../helper';

import depositSuccessImage from '@app/dev/images/success-icon-2.png';

export const DepositSuccess = ({ form, onClose }) => {
  const t = useTranslation();
  const currencyConfig = getCurrencyConfig();
  const amount = normalizeAmount(form?.amount || "");
  const maskedName = maskPlayerName(form?.playerName || t('Player'));
  const playerId = form?.playerId ?? '-';

  return (
    <div className="deposit-success-popup">
      {onClose && (
        <i onClick={onClose} className="global-icon icon-Close close-popup" />
      )}
      <p className="popup-title">{t('Success')}</p>
      <p className="popup-subtitle">{t('Your deposit has been successfully made')}</p>

      <div className="deposit-success-icon">
        <img src={depositSuccessImage} alt={t('Deposit success')} />
      </div>

      <div className="deposit-success-details">
        <p className="user-name">{maskedName}</p>
        <p className="user-id">
          {t('ID')}: <span>{playerId}</span>
        </p>
        <p className="deposit-amount">
          {t('Deposit Amount')}:{' '}
          <span>
            <MoneyAmount config={Config} amount={amount} currencyConfig={currencyConfig} />
          </span>
        </p>
      </div>

      <div className="popup-actions">
        <button type="button" className="popup-confirm-button" onClick={onClose}>
          {t('OK')}
        </button>
      </div>
    </div>
  );
};